/*
* Copyright (C) Regione Lombardia
*/
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Paginator, Sorting, SortingDirectionEnum } from '@models';
import { AnagraficaService } from '@shared/services/anagrafica.service';
import { OperaService } from '@shared/services/opera.service';
import { RilievoService } from '@shared/services/rilievo.service';
import { forkJoin, map, Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class GestioneRilievoDettaglioRilievoResolver implements Resolve<Observable<any>> {
    
    public paginator: Paginator = new Paginator();
    public tableSort: Sorting[] = [
        { field: 'idOpera', direction: SortingDirectionEnum.EMPTY },
        { field: 'denProv', direction: SortingDirectionEnum.EMPTY },
        { field: 'denComune', direction: SortingDirectionEnum.EMPTY },
    ];

    constructor(
        private rilievoService: RilievoService,
        private anagraficaService: AnagraficaService,
        private operaService: OperaService
    ) { }



    resolve(route: ActivatedRouteSnapshot): Observable<any> {
        return forkJoin([
            this.anagraficaService.getMacroTipologiaOpera(),
            this.anagraficaService.getTipologiaOpera(),
            this.anagraficaService.getMateriale(),
            this.anagraficaService.getStatoOpera(),
            this.rilievoService.read(route.params['idRilievo']),
            this.operaService.search({idRilievo: route.params['idRilievo'], trattoIdrico: null, codProv: null, comune: null, codIstat: null, idMaterialeCostruzione: null, idOpera: null, idStato: null, idTipoIntervento: null, idTipologiaOpera: null, provenienza: null }, this.paginator.getQueryPaginator(this.tableSort)),
        ]).pipe(
            map(([
                responseAnagraficaMacroTipologiaOpera,
                responseAnagraficaTipologiaOpera,
                responseAnagraficaMateriale,
                responseAnagraficaStatoOpera,
                responseRilievo,
                responseOpereAssociate,
            ]) => {
                this.rilievoService.rilievoSession = responseRilievo;
                return {
                    rilievo: responseRilievo,
                    opereAssociate: responseOpereAssociate,
                    datalist: {
                        macroTipologiaOpera: responseAnagraficaMacroTipologiaOpera,
                        materiale: responseAnagraficaMateriale,
                        statoOpera: responseAnagraficaStatoOpera,
                        tipologiaOpera: responseAnagraficaTipologiaOpera,
                    }
                };
            }),
        );
    }

}